var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHelpIcon = function SvgHelpIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 288,
    height: 288,
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 288,
    height: 288,
    color: "#9CC5FF",
    enableBackground: "new 0 0 219.15 219.15",
    viewBox: "0 0 219.15 219.15",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc5ff",
    d: "M109.575,0C49.156,0,0.002,49.155,0.002,109.574c0,60.42,49.154,109.576,109.573,109.576s109.573-49.156,109.573-109.576 C219.148,49.155,169.994,0,109.575,0z M109.575,204.15c-52.148,0-94.573-42.427-94.573-94.576C15.002,57.426,57.427,15,109.575,15 s94.573,42.426,94.573,94.574C204.148,161.724,161.723,204.15,109.575,204.15z",
    className: "color000 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc5ff",
    d: "M109.576 152.243c-5.738 0-10.406 4.667-10.406 10.403 0 5.743 4.668 10.415 10.406 10.415 5.738 0 10.406-4.672 10.406-10.415C119.982 156.91 115.314 152.243 109.576 152.243zM109.576 167.243c-2.533 0-4.594-2.063-4.594-4.597 0-2.528 2.061-4.585 4.594-4.585s4.594 2.057 4.594 4.585C114.17 165.181 112.109 167.243 109.576 167.243zM109.575 46.089c-19.154 0-34.737 15.583-34.737 34.736 0 4.142 3.358 7.5 7.5 7.5 4.142 0 7.5-3.358 7.5-7.5 0-10.883 8.854-19.736 19.737-19.736 10.884 0 19.738 8.854 19.738 19.736 0 10.883-8.854 19.737-19.738 19.737-4.142 0-7.5 3.358-7.5 7.5v27.122c0 4.142 3.358 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-20.447c15.56-3.439 27.238-17.333 27.238-33.913C144.313 61.672 128.73 46.089 109.575 46.089z",
    className: "color000 svgShape"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHelpIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/helpIcon.5d4dd3f7294c1f741101f959ef59d038.svg";